import axios from "axios";

export const throwError = (message: string, error: unknown): never => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (typeof data === "string" && data.trim()) {
      throw new Error(data);
    }
    const { message: apiMessage, detail } = (data && typeof data === "object" ? data : {}) as {
      message?: string;
      detail?: string;
    };
    const parts = [apiMessage, detail].filter((part): part is string => typeof part === "string" && part.trim().length > 0);
    throw new Error(parts.length > 0 ? parts.join(". ") : message);
  }
  throw new Error(message);
};
